<template>
  <div class="full d-flex justify-center">
    <div class="breakpoint d-flex align-center justify-center">
      <div class="intro" v-if="!testRunning">
        <div class="temp-log d-flex justify-center mb-3">
          <img
            src="../../assets/img/logo-teman-bakat.png"
            height="100px"
            alt=""
          />
        </div>
        <v-card flat class="rounded-max pa-3 mb-5">
          <div v-if="instruction">
            <p class="text-center">
              {{ instruction.pertanyaan }}
            </p>
            <small class="grey--text"
              >*Pengerjaan journey memiliki batas waktu</small
            >
          </div>
          <v-skeleton-loader
            v-if="!instruction"
            type="list-item-three-line"
          ></v-skeleton-loader>
        </v-card>
        <v-btn rounded color="#1E656C" dark block @click="start"
          >Mulai Journey</v-btn
        >
      </div>
      <div class="intro my-5" v-if="testRunning">
        <div class="d-flex align-center">
          <div class="temp-bar mr-2">
            <v-progress-linear
              color="#1E656C"
              :value="percent"
              rounded
              class="mr-2"
              height="10"
            ></v-progress-linear>
          </div>
          <div class="d-flex">
            <v-btn
              dark
              fab
              class="mr-2"
              small
              color="#1E656C"
              content="Instruksi"
              v-tippy="{
                arrow: true,
                arrowType: 'round',
                animation: 'fade',
                theme: 'light',
              }"
              @click="dialogInstruction = true"
            >
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex justify-end my-5">
          <v-btn
            dark
            class="text-capitalize"
            @click="showRute"
            rounded
            color="#1E656C"
          >
            <v-icon class="mr-2">mdi-information-outline</v-icon>
            Panduan kode rute
          </v-btn>
        </div>
        <div v-if="!loadingQuest">
          <div class="d-flex mb-3" v-for="item in question" :key="item.id">
            <div class="quest mr-3">
              <v-card height="90px" class="pa-3 d-flex align-center">
                {{ item.pertanyaan }}
              </v-card>
            </div>
            <div class="rank">
              <v-card class="wrapper py-2">
                <input
                  type="text"
                  :name="`${item.id}`"
                  :id="`${item.id}`"
                  class="opt1"
                  style="text-transform: uppercase"
                  @input="validate(item.id)"
                  @blur="collectJawaban(item.id)"
                />
              </v-card>
            </div>
          </div>
        </div>
        <div v-if="loadingQuest">
          <div class="d-flex mb-3" v-for="i in 5" :key="i">
            <div class="quest mr-3">
              <v-skeleton-loader height="90px" type="image"></v-skeleton-loader>
            </div>
            <div class="rank">
              <v-skeleton-loader height="90px" type="image"></v-skeleton-loader>
            </div>
          </div>
        </div>
        <div class="paginate d-flex justify-center align-center">
          <div v-if="page > 1 && !loadingSubmit">
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="!loadingPrev"
              @click="getQuestion('prev')"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingPrev"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="last_page !== page">
            <v-btn
              dark
              fab
              small
              color="#1E656C"
              v-if="!loadingNext"
              @click="getQuestion('next')"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingNext"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="last_page == page">
            <v-btn
              dark
              rounded
              color="#1E656C"
              v-if="!loadingNext && !loadingSubmit"
              @click="done()"
            >
              Selesai
            </v-btn>
            <v-btn
              dark
              class="text-capitalize"
              rounded
              color="#1E656C"
              v-if="loadingSubmit"
            >
              <v-progress-circular
                size="20"
                class="mr-2"
                indeterminate
              ></v-progress-circular>
              menyimpan jawaban...
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingNext"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="isUp" style="height: 40vh">-</div>
        </div>
      </div>
      <div class="container_route">
        <div class="white--text">
          <v-row>
            <v-col cols="7"
              ><div class="d-flex align-center" style="height: 100%">
                Kumpulan Alamat
              </div></v-col
            >
            <v-col cols="4"
              ><div class="d-flex align-center text-center">
                Kode Rute Pengantaran
              </div></v-col
            >
            <v-col cols="1" class="pa-0 ma-0">
              <v-btn icon dark small @click="showRute"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </div>
        <div class="temp_route">
          <v-card
            color="#23003a"
            class="pa-3 mb-2 white--text"
            flat
            v-for="item in route"
            :key="item.id"
          >
            <v-row>
              <v-col cols="9"
                ><div class="d-flex align-center" style="height: 100%">
                  {{ item.alamat }}
                </div></v-col
              >
              <v-col cols="2"
                ><div class="d-flex align-center text-center">
                  {{ item.kode }}
                </div></v-col
              >
            </v-row>
          </v-card>
          <div style="height: 50px"></div>
        </div>
      </div>
      <div v-if="instruction">
        <Instruction
          v-bind:dialogInstruction="dialogInstruction"
          v-bind:data="instruction"
          @close="closeDialog"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Instruction from "../instruction/instruction.vue";
export default {
  name: "teskemampuankerja",
  components: {
    Instruction,
  },

  data() {
    return {
      id: 4,
      instruction: null,
      question: null,
      answer: [],
      iam: null,
      testRunning: false,
      page: 1,
      last_page: null,
      loadingNext: false,
      loadingPrev: false,
      loadingQuest: false,
      loadingSubmit: false,
      percent: 100,
      second: null,
      timerTest: null,
      dialogInstruction: false,
      pickedAnswer: null,
      isUp: false,
      route: null,
    };
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timerTest);
    localStorage.removeItem("user-answer");
    localStorage.removeItem("curent_page");
    localStorage.removeItem("testRunning");
    localStorage.removeItem("last_page");
    localStorage.removeItem("remaining-time");
    next();
  },
  mounted() {
    this.getInstruction();
    let curent_page = parseInt(localStorage.getItem("curent_page"));
    let last_page = localStorage.getItem("last_page");
    if (last_page) {
      this.last_page = last_page;
    }
    if (curent_page) {
      this.page = curent_page;
    }
    this.getQuestion();
    this.getRoute();
    let statusTest = localStorage.getItem("testRunning")
      ? localStorage.getItem("testRunning")
      : false;
    if (statusTest) {
      let isUserAnswered = JSON.parse(localStorage.getItem("user-answer"));
      if (isUserAnswered) {
        this.answer = isUserAnswered;
      }
      this.progresBar();
    }
    this.testRunning = statusTest;
  },
  methods: {
    showRute() {
      this.isUp = !this.isUp;
      let el = document.querySelector(".container_route");
      if (this.isUp) {
        el.style.bottom = 0;
      } else if (!this.isUp) {
        el.style.bottom = "-45vh";
      }
    },
    getInstruction() {
      this.$store
        .dispatch("instruksi", this.id)
        .then((data) => {
          this.instruction = data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRoute() {
      this.$store
        .dispatch("getRoute", this.id)
        .then((data) => {
          this.route = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getQuestion(status) {
      if (status == "next") {
        this.loadingNext = true;
        this.page = this.page + 1;
      } else if (status == "prev") {
        this.loadingPrev = true;
        this.page = this.page - 1;
      }
      this.loadingQuest = true;
      localStorage.setItem("curent_page", this.page);
      let data = {
        id: this.id,
        page: this.page,
      };
      this.$store
        .dispatch("question", data)
        .then((data) => {
          window.scrollTo(0, 0);
          this.loadingPrev = false;
          this.loadingNext = false;
          this.second = data.waktu[0].waktu * 60;
          this.loadingQuest = false;
          this.question = data.data;
          this.last_page = data.last_page;
          this.checkPickedAnswer(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkPickedAnswer(questions) {
      if (JSON.parse(localStorage.getItem("user-answer"))) {
        questions.forEach((element) => {
          let pickedAnswer = JSON.parse(
            localStorage.getItem("user-answer")
          ).find((answer) => answer.id === element.id);
          if (pickedAnswer) {
            setTimeout(() => {
              document.getElementById(`${pickedAnswer.id}`).value =
                pickedAnswer.answer;
            }, 200);
          }
        });
      }
    },
    validate(id) {
      let elm = document.getElementById(`${id}`);
      let answer = elm.value.toUpperCase();
      if (answer == "A" || answer == "B" || answer == "C" || answer == "D") {
        return;
      } else {
        elm.value = "";
      }
    },
    collectJawaban(id) {
      let elm = document.getElementById(`${id}`);
      let val = elm.value.toUpperCase();
      if (val !== "") {
        let index = null;
        let answer = null;
        answer = this.answer.filter((value) => value.id === id);
        if (answer.length) {
          index = this.answer.findIndex((element) => element.id === id); // Cek keberadaan soal
          this.answer.splice(index, 1); // hapus yang lama
          this.saveToStorage(id, val); // pilihan baru
        } else {
          this.saveToStorage(id, val);
        }
      }
    },
    saveToStorage(id, val) {
      this.answer.push({
        id: id,
        answer: val,
      });
      localStorage.setItem("user-answer", JSON.stringify(this.answer));
    },
    start() {
      this.testRunning = true;
      localStorage.setItem("testRunning", this.testRunning);
      localStorage.setItem("last_page", this.last_page);
      this.progresBar();
    },

    done() {
      let answer = JSON.parse(localStorage.getItem("user-answer"));

      if (answer) {
        this.loadingSubmit = true;
        let result = {};
        answer.map((item) => {
          result[item.id] = item.answer;
        });
        let body = { jawaban: JSON.stringify(result) };
        let data = {
          id: this.id,
          body: body,
        };
        this.$store
          .dispatch("postAnswer", data)
          .then((data) => {
            this.loadingSubmit = false;
            // console.log(data.hasil);
            let storage = {
              answer: body,
              result: JSON.stringify(data.hasil.skill),
            };
            localStorage.setItem("teskemampuankerja", JSON.stringify(storage));
            clearInterval(this.timerTest);
            localStorage.removeItem("user-answer");
            localStorage.removeItem("curent_page");
            localStorage.removeItem("testRunning");
            localStorage.removeItem("last_page");
            localStorage.removeItem("remaining-time");
            let completedMission = JSON.parse(
              localStorage.getItem("completed")
            );
            if (completedMission) {
              let isAnswered = completedMission.filter((i) => i.id == this.id);
              if (!isAnswered.length) {
                completedMission.push({
                  id: this.id,
                  journey: "Tes Kemampuan Kerja",
                  order: completedMission.length + 1,
                  img: `https://nos.wjv-1.neo.id/temanbakat/misi/icon/${this.id}.png`,
                });
                localStorage.setItem(
                  "completed",
                  JSON.stringify(completedMission)
                );
              }
            } else {
              let mission = [
                {
                  id: this.id,
                  journey: "Tes Kemampuan Kerja",
                  order: 1,
                  img: `https://nos.wjv-1.neo.id/temanbakat/misi/icon/${this.id}.png`,
                },
              ];
              localStorage.setItem("completed", JSON.stringify(mission));
            }
            this.$router.push("/result/teskemampuankerja");
          })
          .catch((err) => {
            console.log(err);
            this.loadingSubmit = false;
          });
      }
    },
    progresBar() {
      let remainingTime = localStorage.getItem("remaining-time"); // waktu tersisa
      let runningTime = null; // detik berjalan
      if (remainingTime) {
        runningTime = remainingTime;
      } else {
        runningTime = this.second;
      }
      this.timerTest = setInterval(() => {
        runningTime--;
        this.percent = (runningTime / this.second) * 100;
        localStorage.setItem("remaining-time", runningTime);
        if (runningTime == 0) {
          clearInterval(this.timerTest);
          this.done();
        }
      }, 1000);
    },
    closeDialog() {
      this.dialogInstruction = false;
    },
  },
};
</script>

<style scoped>
.rank {
  width: 15%;
}
.quest {
  width: 85%;
}
.temp-bar {
  width: 90%;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.opt1 {
  width: 50px;
  height: 50px;
  border: 1px solid #23003a;
  color: #1e656c;
  text-align: center;
  font-weight: bold;
}
.opt1:focus {
  outline: none;
}
.container_route {
  position: fixed;
  width: 37%;
  background: #1e656c;
  height: 40vh;
  bottom: -45vh;
  transition: 0.5s all;
  padding: 10px 10px 0 10px;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  -webkit-box-shadow: 0px 0px 49px -11px rgba(30, 101, 108, 1);
  -moz-box-shadow: 0px 0px 49px -11px rgba(30, 101, 108, 1);
  box-shadow: 0px 0px 49px -11px rgba(30, 101, 108, 1);
}
.temp_route {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  background: #fff;
  border-radius: 10px 10px 0 0;
  padding: 5px;
}

@media (max-width: 1200px) {
  .container_route {
    width: 50%;
  }
  .opt1 {
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 768px) {
  .container_route {
    width: 98%;
  }
  .opt1 {
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 576px) {
  .container_route {
    width: 100%;
  }
  .opt1 {
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 396px) {
  .container_route {
    width: 100%;
  }
  .opt1 {
    width: 40px;
    height: 40px;
  }
}
</style>
